// ============================================================
// audio/musicVoid.js — (legacy) void procedural music
// ============================================================
// Delegates to the single CHILL MUSIC track. Idempotent — never restarts.
import { startMusic } from './musicChill.js';

export function startVoidMusic() { startMusic(); }
export function stopVoidMusic()  { /* no-op — chill track stays playing */ }
